module.exports = __webpack_public_path__ + "img/frontCard.72824714.png";